<template>
  <v-card
      color="green"
      flat
      tile
      class="align-center"
  >
    <v-toolbar style="background: darkgreen; height: 100px" class="align-center">
      <!--<v-app-bar-nav-icon></v-app-bar-nav-icon>-->
      <router-link to="/" class="align-self-center px-10">
        <img src="https://evidenz.carolinholat.de/Evidenz_der_Vernunft_Signature.png" style="height: 80px; margin-top: 20px"/>
      </router-link>
      <v-toolbar-title style="color: yellow; font-weight: bold; margin-left: 20px" class="yellow--text align-self-center" align="center">
        <h3 class="yellow--text align-self-center">Evidenz der Vernunft</h3>
      </v-toolbar-title>
      <v-spacer></v-spacer>
     <!-- <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs"
                 v-on="on">
            <v-icon>mdi-account-circle</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item
          >
            <v-list-item-title @click="authLogin()">Login</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>-->
    </v-toolbar>
  </v-card>
</template>

<script>
    export default {
        name: "TitleBar",
      methods: {
          authLogin() {
            this.$store.dispatch('auth0Login')
          }
      }
    }
</script>

<style scoped>
    .routerLink {
        text-decoration: none;
        color: whitesmoke;
    }
    .routerLink:hover {
        text-decoration: none;
        color: darkslategrey;
    }

</style>
